import { domainCodeAtom } from '@australiangreens/ag-internal-components';
import { useAuth0 } from '@auth0/auth0-react';
import { usePrefetchQuery, useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { FilterCriteria } from './filterCriteriaReducer';
import { hydrateQuickFilterCriteria } from './hydrateQuickFilterCriteria';

function useQuickFilter(filter: FilterCriteria | null, searchId: number | undefined) {
  const { getAccessTokenSilently, user } = useAuth0();
  const domainCode = useAtomValue(domainCodeAtom);

  return async () => {
    const token = await getAccessTokenSilently();
    return hydrateQuickFilterCriteria({
      filter,
      searchId,
      token,
      domainCode,
      userSub: user?.sub ?? '',
    });
  };
}

export const useLoadQuickFilter = (filter: FilterCriteria | null, searchId: number | undefined) => {
  const domainCode = useAtomValue(domainCodeAtom);
  const loadQF = useQuickFilter(filter, searchId);

  return useQuery({
    queryKey: ['search', 'quick', domainCode, searchId],
    queryFn: loadQF,
    refetchOnWindowFocus: false,
  });
};

export const usePrefetchQuickFilter = (
  filter: FilterCriteria | null,
  searchId: number | undefined
) => {
  const domainCode = useAtomValue(domainCodeAtom);
  const loadQF = useQuickFilter(filter, searchId);

  return usePrefetchQuery({
    queryKey: ['search', 'quick', domainCode, searchId],
    queryFn: loadQF,
  });
};
